var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPictoMateriaux(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.206,
    height: 36.91,
    viewBox: "0 0 27.206 36.91",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_26",
    "data-name": "Groupe 26",
    transform: "translate(-912.337 -672.464)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_25",
    "data-name": "Groupe 25",
    transform: "translate(913.002 672.964)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_24",
    "data-name": "Groupe 24",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_6",
    "data-name": "Trac\\xE9 6",
    d: "M937.895,687.654a1.066,1.066,0,0,1-.156-1.122,6.446,6.446,0,0,0-4.542-8.489,1.024,1.024,0,0,1-.851-.757,6.458,6.458,0,0,0-12.18-.027c-.135.372-.266.6-.746.632a6.438,6.438,0,0,0-5.482,9.054,1.041,1.041,0,0,1-.049,1.076,6.48,6.48,0,0,0,8.456,9.088c.88-.425,1.213-.186,1.175.8a22.33,22.33,0,0,1-2,8.951c-.289.6-.635.945-1.346.825a8.031,8.031,0,0,0-1.042-.012c-.474-.017-.976,0-.962.624.012.567.484.581.935.579,2.436-.009,4.873,0,7.309,0s4.873,0,7.309,0c.435,0,.916.03.935-.57.021-.656-.486-.633-.949-.63-.721,0-1.444-.029-2.162.012a.852.852,0,0,1-.922-.541,19.712,19.712,0,0,1-1.932-6.608c-.1-.789-.138-1.587-.189-2.382-.067-1.037.411-1.364,1.351-.948a6.278,6.278,0,0,0,5.26.036A6.479,6.479,0,0,0,937.895,687.654Zm-8.359,19.988h-6.988a.663.663,0,0,1,.026-.211,22.035,22.035,0,0,0,2.108-9.061c.023-.648.2-.824.831-.634a2.231,2.231,0,0,0,1.106.029c.618-.146.7.141.7.644a22.267,22.267,0,0,0,.407,3.7A19.971,19.971,0,0,0,929.535,707.642Zm6.968-12.864a5.234,5.234,0,0,1-6.5,1.136,1.228,1.228,0,0,0-1.412,0,4.5,4.5,0,0,1-5.05-.142,1.012,1.012,0,0,0-1.272-.006,5.273,5.273,0,0,1-7.068-7.574,1.027,1.027,0,0,0,.056-1.276,4.936,4.936,0,0,1-.5-3.888,5.008,5.008,0,0,1,4.238-3.89,5.074,5.074,0,0,1,5.4,2.494c.237.373.468.775.983.452s.271-.714.04-1.09a6.01,6.01,0,0,0-3.611-2.81c-.655-.176-.6-.432-.38-.915a5.362,5.362,0,0,1,5.1-3.1,5.139,5.139,0,0,1,4.673,3.562,1.759,1.759,0,0,0,1.584,1.49,5.1,5.1,0,0,1,4.111,4.6,5.25,5.25,0,0,1-3.516,5.535c-.42.158-.859.3-.676.86.2.621.683.41,1.11.259a6.583,6.583,0,0,0,3.006-2.2A5.226,5.226,0,0,1,936.5,694.778Z",
    transform: "translate(-913.002 -672.964)",
    fill: "#8abf69",
    stroke: "#8abf69",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_7",
    "data-name": "Trac\\xE9 7",
    d: "M930.015,708.324a4.481,4.481,0,0,0-4.219,4.223c0,.44.133.767.589.777.4.009.575-.273.62-.685a3.156,3.156,0,0,1,3.1-3.1c.407-.061.662-.2.641-.643C930.729,708.533,930.459,708.33,930.015,708.324Z",
    transform: "translate(-923.245 -701.273)",
    fill: "#8abf69",
    stroke: "#8abf69",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_8",
    "data-name": "Trac\\xE9 8",
    d: "M980.549,697.018A.494.494,0,0,0,981,696.8a2.573,2.573,0,0,1,1.184-.853.541.541,0,0,0,.349-.726.578.578,0,0,0-.767-.4,3.211,3.211,0,0,0-1.7,1.249.575.575,0,0,0-.014.7A.54.54,0,0,0,980.549,697.018Z",
    transform: "translate(-966.589 -690.434)",
    fill: "#8abf69",
    stroke: "#8abf69",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9",
    "data-name": "Trac\\xE9 9",
    d: "M999.661,732.26a3.064,3.064,0,0,0-1.886,1.422.515.515,0,0,0,.214.708.469.469,0,0,0,.674-.026,3.973,3.973,0,0,1,1.424-1.033.485.485,0,0,0,.225-.642A.619.619,0,0,0,999.661,732.26Z",
    transform: "translate(-980.815 -720.437)",
    fill: "#8abf69",
    stroke: "#8abf69",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_10",
    "data-name": "Trac\\xE9 10",
    d: "M954.433,732.867c-.047-.443-.3-.7-.74-.576a2.908,2.908,0,0,0-1.706,1.217.584.584,0,0,0,.092.856.541.541,0,0,0,.84-.114,2.394,2.394,0,0,1,1.112-.814A.541.541,0,0,0,954.433,732.867Z",
    transform: "translate(-944.099 -720.437)",
    fill: "#8abf69",
    stroke: "#8abf69",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11",
    "data-name": "Trac\\xE9 11",
    d: "M979.071,764.316a.576.576,0,0,0-.574-.556,2.939,2.939,0,0,0-1.972,1.4.59.59,0,0,0,.218.721.493.493,0,0,0,.727-.08,3,3,0,0,1,1.293-.941A.5.5,0,0,0,979.071,764.316Z",
    transform: "translate(-963.826 -745.655)",
    fill: "#8abf69",
    stroke: "#8abf69",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_12",
    "data-name": "Trac\\xE9 12",
    d: "M937.936,758.959a.547.547,0,0,0-.767-.45,2.988,2.988,0,0,0-1.658,1.173.6.6,0,0,0,.1.914.544.544,0,0,0,.831-.165,2.29,2.29,0,0,1,1.06-.767A.62.62,0,0,0,937.936,758.959Z",
    transform: "translate(-930.891 -741.423)",
    fill: "#8abf69",
    stroke: "#8abf69",
    strokeWidth: 1
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictoMateriaux);
export default __webpack_public_path__ + "static/media/picto-materiaux.f5118968e5bc5d57497a5ccb35521125.svg";
export { ForwardRef as ReactComponent };